import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영] Service 성능정보 조회
   * @author jeee12
   * @param  {Object} params objId
   * @return {List}        service에 포함된 장비들의 성능정보
   */
  getServicePerformance(params) {
    return axios.post(`${baseUrl}/performance/get-service-performance.do`, params);
  },
  getServiceAnalysisPerformance(params) {
    return axios.post(`${baseUrl}/performance/get-service-analysis-performance.do`, params);
  },
  /**
   * [성능/운영>요약] 서비스 구성정보 위젯 정보 조회
   * @author jeee12
   * @param  {Object} params serviceId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getServiceConfigurationInfo(params) {
    return axios.get(`${baseUrl}/performance/summary/service/get-configuration-info.do`, { params });
  },
  /**
   * [성능/운영 > 운영 > 중요프로세스] 서비스 - 중요프로세스 조회 (테이블)
   * @author Song
   * @param  {Object} params serviceId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getServiceMajorProcessData(params) {
    return axios.post(`${baseUrl}/performance/summary/service/get-service-major-process-data.do`, params);
  },
  /**
   * [성능/운영 > 운영 > 중요프로세스] 서비스 - 중요프로세스 - 서비스에 포함된 서버들의 과점유 설정 데이터 조회
   * @author Song
   * @param  {Object} params serviceId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getProcessOverloadSettings(params) {
    return axios.post(`${baseUrl}/performance/summary/service/get-process-over-load-settings.do`, params);
  },
  /**
   * [성능/운영 > 운영 > 중요프로세스] 서비스 - 서비스 포트 성능 및 정보 리스트 조회
   * @author Song
   * @param  {Object} params serviceId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getServiceMajorPortList(params) {
    return axios.post(`${baseUrl}/performance/summary/service/get-service-major-port-list.do`, params);
  },
  /**
   * [성능/운영 > 운영 > 중요프로세스] 서비스맵 - 관련 mapId 리스트를 얻어온다.
   * @author jeee12
   * @param  {Object} params serviceId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getServiceMapInfoList(params) {
    return axios.get(`${baseUrl}/performance/summary/service/get-service-map-info-list.do`, { params });
  },
  /**
   * [성능/운영 > 운영 > 중요프로세스] 서비스맵 저장/수정
   * @author jeee12
   * @param  {Object} params serviceId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  setServiceMapInfoList(params) {
    return axios.post(`${baseUrl}/performance/summary/service/set-service-map-info-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/service/service.js